<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div v-if="form.config" slot="body">
          <!-- <bita-formgroup
            title="اطلاعات کلی"
            class="row justify-content-center"
          > -->
          <div class="row">
            <bita-input
              ref="name"
              type="text"
              name="name"
              label="نام"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.name"
            />
            <bita-select
              id="statuses"
              name="statuses"
              label="وضعیت"
              ref="statuses"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="[
                { value: 1, title: 'فعال' },
                { value: 0, title: 'غیرفعال' },
              ]"
              data-text-field="title"
              data-value-field="value"
              v-model="form.status"
            />
            <!-- <bita-datepicker ref="expireDate" type="date" name="expireDate" label="تاریخ انقضا" rules="required"
              :validation-container-class="colWidth" input-class="form-control" v-model="form.config.expire_date" /> -->
            <bita-input
              ref="expireDays"
              type="number"
              name="expireDays"
              label="منقضی شدن نوبت(روز)"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.config.expire_days"
            />
            <bita-input
              ref="price"
              type="text"
              name="price"
              label="قیمت"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.config.price"
              :subtitle="
                form.config.price
                  ? $thousandSeprator($round(form.config.price, 3)) + $cashUnit
                  : ''
              "
            />
            <bita-select
              ref="terminals"
              name="terminals"
              label="ترمینال"
              rules="required"
              validation-container-class="col-lg-8"
              input-class="form-control"
              :data-source="terminals"
              data-text-field="name"
              data-value-field="id"
              v-model="form.terminal_id"
            />
            <bita-select
              ref="terminals"
              name="terminals"
              label="وضعیت شیفت ها"
              rules="required"
              validation-container-class="col-lg-4"
              input-class="form-control"
              :data-source="shiftStatuses"
              data-text-field="text"
              data-value-field="value"
              v-model="form.config.is_active_shifts"
            />
            <bita-select
              id="check_geo_for_ticket"
              name="check_geo_for_ticket"
              rules="required"
              label="موقعیت جغرافیایی سالن چک شود؟"
              validation-container-class="col-lg-4"
              input-class="form-control"
              data-text-field="title"
              data-value-field="value"
              :data-source="[
                { title: 'بله', value: 1 },
                { title: 'خیر', value: 0 },
              ]"
              v-model="form.config.check_geo_for_ticket"
            />
            <bita-textarea
              name="salon_message"
              class="col-12"
              inputClass="col-12 form-control"
              place-holder="پیغام"
              v-model.lazy="form.salon_message"
            />
          </div>
        </div>
      </bita-form>
      <div slot="footer" class="d-flex flex-column flex-md-row">
        <div class="col-12 col-md-2" v-if="!propsData.id">
          <bita-bootbutton
            type="primary"
            title="ذخیره"
            icon="fa fa-check"
            class="w-100"
            @click.native="handleSubmit()"
          />
        </div>
        <div class="col-12 col-md-2" v-if="propsData.id">
          <bita-bootbutton
            type="primary"
            title="بروزرسانی"
            icon="fa fa-check"
            class="w-100"
            @click.native="handleSubmit()"
          />
        </div>
        <div class="col-12 col-md-2">
          <bita-bootbutton
            class="mr-2 bg-transparent border-0 text-danger w-100"
            type="danger"
            title="بستن"
            icon="fas fa-times"
            data-dismiss="modal"
            @click.native="
              () => {
                $emit('change-status-modal');
              }
            "
          />
        </div>
      </div>
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    propsData: {
      type: Object,
    },
    propsTerminals: [],
  },
  data() {
    return {
      colWidth: "col-lg-4",
      shiftStatuses: [
        {
          text: "فعال",
          value: 1,
        },
        {
          text: "غیر فعال",
          value: 0,
        },
      ],
      terminals: [],
      form: {},
    };
  },
  watch: {
    propsData: function(_data) {
      this.form = _data;
    },
    propsTerminals: function(_data) {
      this.terminals = _data;
    },
  },
  methods: {
    toggleLoading() {
      this.$emit("isLoading");
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.form);
        }
      });
    },
    onCloseModal() {
      this.$refs.form.reset();
    },
  },
};
</script>
